import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LegendPosition } from '@swimlane/ngx-charts';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  standalone: false
})
export class AdminDashboardComponent implements OnInit {

  constructor(private router: Router, private apiService: ApiService) { }

  activeFilter: string = 'TODAY';

  legendPosition = LegendPosition;

  dashboardCardsData: any;
  lineChartData: any;

  errorFetchingCardData: boolean = false;
  errorFetchingLineChartData: boolean = false;


  lineChartDummy: any[] =
    [
      {
        "name": "Collections",
        "series": [
          {
            "name": "00:00",
            "value": 100
          },
          {
            "name": "01:00",
            "value": 0
          },
          {
            "name": "02:00",
            "value": 0
          },
          {
            "name": "03:00",
            "value": 0
          },
          {
            "name": "04:00",
            "value": 0
          },
          {
            "name": "05:00",
            "value": 0
          },
          {
            "name": "06:00",
            "value": 0
          },
          {
            "name": "07:00",
            "value": 0
          },
          {
            "name": "08:00",
            "value": 0
          },
          {
            "name": "09:00",
            "value": 0
          },
          {
            "name": "10:00",
            "value": 0
          },
          {
            "name": "11:00",
            "value": 0
          },
          {
            "name": "12:00",
            "value": 0
          },
          {
            "name": "13:00",
            "value": 0
          },
          {
            "name": "14:00",
            "value": 0
          },
          {
            "name": "15:00",
            "value": 0
          },
          {
            "name": "16:00",
            "value": 0
          },
          {
            "name": "17:00",
            "value": 0
          },
          {
            "name": "18:00",
            "value": 0
          },
          {
            "name": "19:00",
            "value": 0
          },
          {
            "name": "20:00",
            "value": 0
          },
          {
            "name": "21:00",
            "value": 0
          },
          {
            "name": "22:00",
            "value": 0
          },
          {
            "name": "23:00",
            "value": 0
          }
        ]
      }
    ]



  // options
  legend: boolean = false;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = false;
  showXAxisLabel: boolean = false;
  xAxisLabel: string = 'Year';
  yAxisLabel: string = 'Population';
  timeline: boolean = true;

  colorScheme: any = {
    domain: ['#9FC1FB', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  getPercentageColor(value: number | null | undefined): string {
    if (value == null) return '#93A3AB'; // fallback for undefined/null
    if (value > 0) return '#65C565';     // green
    if (value < 0) return '#F04438';     // red
    return '#93A3AB';                    // neutral
  }

  ngOnInit(): void {

    this.getDashboardData();
    this.getLineChartData(this.activeFilter)
  }

  goToSummary(period: string) {
    this.router.navigate(['/admin/summary-dashboard',], { queryParams: { period } })
  }

  setActiveFilter(filter: string) {
    this.activeFilter = filter;
    this.getDashboardData()
    this.getLineChartData(filter);
  }


  get lineChartTotal() {
    switch (this.activeFilter) {
      case 'TODAY':
        return this.dashboardCardsData?.dailyDate?.totalAmount;
      case 'WEEK':
        return this.dashboardCardsData?.weeklyDate?.totalAmount;
      case 'MONTH':
        return this.dashboardCardsData?.monthlyDate?.totalAmount;
      case 'YEAR':
        return this.dashboardCardsData?.yearlyDate?.totalAmount;
    }

  }


  get lineChartPercentage() {
    switch (this.activeFilter) {
      case 'TODAY':
        return this.dashboardCardsData?.dailyDate?.percentage;
      case 'WEEK':
        return this.dashboardCardsData?.weeklyDate?.percentage;
      case 'MONTH':
        return this.dashboardCardsData?.monthlyDate?.percentage;
      case 'YEAR':
        return this.dashboardCardsData?.yearlyDate?.percentage;
    }

  }



  getDashboardData() {

    this.apiService.get('/dashboard/dash-amount').subscribe((res: any) => {
      this.dashboardCardsData = res;
    },
      (error) => {
        this.errorFetchingCardData = true
      })
  }


  getLineChartData(period: string) {
    this.apiService.get('/dashboard/dash-chart?period=' + period).subscribe((res: any) => {
      const series = res.map((item) => ({
        "name": item.period,
        "value": item.totalAmount
      }));


      this.lineChartData = [{
        name: 'Collections',
        series
      }]


    },
      (error) => {
        this.errorFetchingLineChartData = true
      })
  }

}
